module.exports = __webpack_public_path__ + "static/mona-de9806b406b45767958e7fd63a21b4d8.png";